import { render, staticRenderFns } from "./ServiceMerchant.vue?vue&type=template&id=09843f68&"
import script from "./ServiceMerchant.vue?vue&type=script&lang=js&"
export * from "./ServiceMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports